module.exports = __webpack_public_path__ + "static/media/us_dol_logo.199c1e34.webp";